import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";

export const useCalendarFormatter = (hasTranslations = true) => {
  const { t, i18n } = useTranslation(["translation"]);

  if (!hasTranslations || isEmpty(i18n))
    return {
      sameDay: `[i dag]`,
      nextDay: `[i morgen]`,
      nextWeek: "dddd",
      lastDay: `[i går]`,
      lastWeek: `[sidste] dddd`,
      sameElse: "dddd, D/M",
    };

  const calendarFormatter = {
    sameDay: `[${t("translation:today").toLowerCase()}]`,
    nextDay: `[${t("translation:tomorrow")}]`,
    nextWeek: "dddd",
    lastDay: `[${t("translation:yesterday")}]`,
    lastWeek: `[${t("translation:last")}] dddd`,
    sameElse: "dddd, D/M",
  };

  return calendarFormatter;
};
